// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"awxwA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSkeletons", ()=>createSkeletons);
parcelHelpers.export(exports, "addSkeleton", ()=>addSkeleton);
parcelHelpers.export(exports, "removeExtraSkeletons", ()=>removeExtraSkeletons);
parcelHelpers.export(exports, "getAvailableSkeleton", ()=>getAvailableSkeleton);
parcelHelpers.export(exports, "displayStars", ()=>displayStars);
parcelHelpers.export(exports, "getStars", ()=>getStars);
parcelHelpers.export(exports, "getRadioLink", ()=>getRadioLink);
var _translatorJs = require("./translator.js");
var _customHeaderJs = require("../custom/CustomHeader.js");
var _customFooterJs = require("../custom/CustomFooter.js");
var _skeletonJs = require("../custom/Skeleton.js");
(0, _translatorJs.i18n).setGlobalData({
    year: new Date().getFullYear()
});
$("document").ready(function() {
// const burgerBtn = document.getElementById("burgerBtn");
// const mobileNav = document.getElementById("mobileNav");
// burgerBtn.addEventListener("click", () => {
//   burgerBtn.classList.toggle("open");
//   mobileNav.classList.toggle("open");
// });
});
function createSkeletons(template, count = 2, container) {
    const references = [];
    for(let i = 0; i < count; i++){
        const clone = template.content.cloneNode(true);
        const skeleton = clone.querySelector("custom-skeleton");
        skeleton.classList.add("page-placeholder"); //marked as temporary
        references.push(skeleton);
        container.appendChild(clone);
    }
    return references;
}
function addSkeleton(templateNode, container) {
    const clone = templateNode.content.cloneNode(true);
    const newCard = clone.querySelector("custom-skeleton");
    container.appendChild(clone);
    //return [clone, newCard];
    return newCard;
}
function removeExtraSkeletons(container) {
    const leftoverSkeletons = container.querySelectorAll("custom-skeleton.page-placeholder");
    leftoverSkeletons.forEach((skeleton)=>{
        skeleton.remove();
    });
}
function getAvailableSkeleton(key, container, template) {
    let existingCard = document.getElementById(key);
    if (existingCard) return existingCard;
    let availableSkeleton = container.querySelector("custom-skeleton.page-placeholder");
    if (availableSkeleton) {
        availableSkeleton.classList.remove("page-placeholder");
        return availableSkeleton;
    } else return addSkeleton();
}
function displayStars(container, score) {
    //const container = document.getElementById("star-container");
    // 1. Get the numeric rating from data attribute and round it
    const rating = Math.round(parseFloat(score || container.getAttribute("data-rating")));
    const maxStars = 5;
    // 2. Generate filled and empty star strings using .repeat()
    const filledStars = "\u2605".repeat(rating);
    const emptyStars = "\u2606".repeat(maxStars - rating);
    // 3. Inject the complete star string into the element
    container.innerHTML = filledStars + emptyStars;
}
function getStars(rating) {
    console.log("rating: ", rating);
    const ratingNum = Math.round(parseFloat(rating));
    const maxStars = 5;
    // 2. Generate filled and empty star strings using .repeat()
    const filledStars = "\u2605".repeat(rating);
    const emptyStars = "\u2606".repeat(maxStars - rating);
    return filledStars + emptyStars;
}
function getRadioLink(radioName) {
    if (radioName.includes("-")) radioName = radioName.replace(/-/g, "--");
    return "chat/" + radioName.replace(/\s+/g, "-");
}

},{"./translator.js":"dXlaA","../custom/CustomHeader.js":"3aCFy","../custom/CustomFooter.js":"kTvFh","../custom/Skeleton.js":"bBdLh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dXlaA":[function(require,module,exports,__globalThis) {
// i18n.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Translator", ()=>Translator);
parcelHelpers.export(exports, "i18n", ()=>i18n);
var _enJson = require("raw:../locales/en.json");
var _enJsonDefault = parcelHelpers.interopDefault(_enJson);
var _esJson = require("raw:../locales/es.json");
var _esJsonDefault = parcelHelpers.interopDefault(_esJson);
const localeUrls = {
    en: (0, _enJsonDefault.default),
    es: (0, _esJsonDefault.default)
};
class Translator {
    constructor(){
        this.currentTranslations = {};
        this.currentLang = "en";
        this.userData = {};
        // Define languages your application actually supports
        this.supportedLanguages = [
            "en",
            "es"
        ];
        this.defaultFallbackLanguage = "en";
        // Toggle this to false in production to keep console clean
        this.debugMode = true;
    }
    setGlobalData(data) {
        this.userData = {
            ...this.userData,
            ...data
        };
    }
    // UPDATED: Core string replacement logic with built-in missing key detection
    t(key, elementData = {}) {
        // 1. Check if the key actually exists in our downloaded dictionary file
        if (!this.currentTranslations.hasOwnProperty(key)) {
            if (this.debugMode) console.warn(`[i18n Warning]: Missing translation key "${key}" for language "${this.currentLang}"`);
            // Fallback strategy: return the key text cleanly formatted so the UI layout doesn't break
            // e.g., "missing_key_name" becomes "[missing_key_name]"
            return `[${key}]`;
        }
        let translation = this.currentTranslations[key];
        const combinedData = {
            ...this.userData,
            ...elementData
        };
        Object.keys(combinedData).forEach((placeholder)=>{
            translation = translation.replaceAll(`{${placeholder}}`, combinedData[placeholder]);
        });
        return translation;
    }
    // NEW: Recursive deep scanner that bypasses Shadow DOM boundaries
    translatePage() {
        // Define a helper closure to handle the recursive crawl
        const scanNode = (rootNode)=>{
            if (!rootNode) return;
            // Target any element that has either translation tag setup configured
            rootNode.querySelectorAll("[data-i18n], [data-i18n-attr]").forEach((element)=>{
                const textKey = element.getAttribute("data-i18n");
                const attrConfigStr = element.getAttribute("data-i18n-attr");
                // Read variable data parameters (if any)
                const dataAttr = element.getAttribute("data-i18n-data");
                const elementData = dataAttr ? JSON.parse(dataAttr) : {};
                // 1. Handle Standard Inner Text Content Translation
                if (textKey) element.textContent = this.t(textKey, elementData);
                // 2. Handle Multiple Attribute Translations Dynamic Setup
                if (attrConfigStr) try {
                    // Try parsing the attribute value as a JSON mapping configuration object
                    const attrMapping = JSON.parse(attrConfigStr);
                    // Loop over each specified target attribute (e.g., placeholder, title)
                    Object.keys(attrMapping).forEach((targetHtmlAttr)=>{
                        const dictionaryKey = attrMapping[targetHtmlAttr];
                        const translatedValue = this.t(dictionaryKey, elementData);
                        element.setAttribute(targetHtmlAttr, translatedValue);
                    });
                } catch (e) {
                    // FALLBACK: If it isn't valid JSON, treat it like our old single string approach
                    if (textKey) element.setAttribute(attrConfigStr, this.t(textKey, elementData));
                }
            });
            // Deep crawl past any open component roots
            rootNode.querySelectorAll("*").forEach((childElement)=>{
                if (childElement.shadowRoot) scanNode(childElement.shadowRoot);
            });
        };
        // Kick off the initial scan starting from the main document body
        scanNode(document.body);
    }
    async changeLanguage(lang) {
        try {
            // Fallback validation check
            if (!this.supportedLanguages.includes(lang)) lang = this.defaultFallbackLanguage;
            const fileUrl = localeUrls[lang];
            if (!fileUrl) {
                console.error(`Locale ${lang} not supported`);
                return;
            }
            const response = await fetch(fileUrl);
            if (!response.ok) throw new Error(`Could not load translations`);
            this.currentTranslations = await response.json();
            this.currentLang = lang;
            this.translatePage();
            document.documentElement.lang = lang;
            localStorage.setItem("preferredLanguage", lang);
            const event = new CustomEvent("app:lang-changed", {
                detail: {
                    language: lang
                }
            });
            window.dispatchEvent(event);
        } catch (error) {
            console.error("Translation Engine Error:", error);
        }
    }
    // NEW DETECT AND INITIALIZE SYSTEM
    init(dropdownId) {
        // 1. Check if user has an explicit manual save in localStorage
        const savedLang = localStorage.getItem("preferredLanguage");
        // 2. Read browser settings and isolate the first two letters (e.g., "en-US" -> "en")
        const browserLang = navigator.language.slice(0, 2);
        // 3. Determine target language: Saved Preference -> Browser Language -> Default Fallback
        let targetedLanguage = this.defaultFallbackLanguage;
        if (savedLang && this.supportedLanguages.includes(savedLang)) targetedLanguage = savedLang;
        else if (this.supportedLanguages.includes(browserLang)) targetedLanguage = browserLang;
        // 4. Update the visual dropdown selection state matching our decision
        const switcher = document.getElementById(dropdownId);
        if (switcher) {
            switcher.value = targetedLanguage;
            switcher.addEventListener("change", (e)=>this.changeLanguage(e.target.value));
        }
        // 5. Fire up the translation dictionary pipeline
        this.changeLanguage(targetedLanguage);
    }
    initFromElement(switcherElement) {
        const savedLang = localStorage.getItem("preferredLanguage");
        const browserLang = navigator.language.slice(0, 2);
        let targetedLanguage = this.defaultFallbackLanguage;
        console.log("lang chosen: ", targetedLanguage);
        if (savedLang && this.supportedLanguages.includes(savedLang)) targetedLanguage = savedLang;
        else if (this.supportedLanguages.includes(browserLang)) targetedLanguage = browserLang;
        if (switcherElement) {
            switcherElement.value = targetedLanguage;
            switcherElement.addEventListener("change", (e)=>this.changeLanguage(e.target.value));
        }
        this.changeLanguage(targetedLanguage);
    }
}
const i18n = new Translator();

},{"raw:../locales/en.json":"2xR9A","raw:../locales/es.json":"eZ7GW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2xR9A":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("726UG");

},{}],"eZ7GW":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9lLI3");

},{}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"3aCFy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _translatorJs = require("../scripts/translator.js");
var _globalCss = require("url:../styles/global.css");
var _globalCssDefault = parcelHelpers.interopDefault(_globalCss);
var _logoPng = require("url:../images/logo.png");
var _logoPngDefault = parcelHelpers.interopDefault(_logoPng);
class CustomHeader extends HTMLElement {
    constructor(){
        super();
        // Crucial: Must be set to 'open' so our scanner can access it
        this.attachShadow({
            mode: "open"
        });
        //this.shadowRoot.adoptedStyleSheets = [globalStyles];
        // 1. Initialize private backing fields with default fallback URLs
        this._androidUrl = "https://play.google.com/store/apps/details?id=app.myandroidhello.com.chatmurcianys&pcampaignid=web_share";
        this._iosUrl = "https://apps.apple.com/in/app/chatmurcianys/id6480422290";
        this._desktopUrl = "https://chatmurcianys.com";
    }
    // 1. Tell the component which attributes to watch
    static get observedAttributes() {
        return [
            "android-url",
            "ios-url",
            "desktop-url"
        ];
    }
    // 2. Automatically re-run the logic if an attribute changes
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue && this.shadowRoot.innerHTML) this.setupDownloadButton();
    }
    render() {
        this.shadowRoot.innerHTML = `
    <link rel="stylesheet" href="${0, _globalCssDefault.default}">
      <!-- Top Navigation Bar -->
    <header class="main-header">
      <div class="header-container">
        <a href="index.html" class="logo-area">
          <div class="logo-circle">
            <img
              src="${0, _logoPngDefault.default}"
              alt="ChatMurcianys Logo"
              data-i18n-attr='{"alt":"nav_logo"}'
            />
          </div>
          <span class="logo-text">ChatMurcianys</span>
        </a>

        <!-- Navigation Menu -->
        <nav class="nav-menu" id="mobileNav">
          <a href="index.html" class="nav-item active" data-i18n="nav_home"
            >Home</a
          >
          <a href="chat.html" class="nav-item">Chat</a>
          <a href="features.html" class="nav-item" data-i18n="nav_features"
            >Features</a
          >
          <a
            href="https://play.google.com/store/apps/details?id=app.myandroidhello.com.chatmurcianys&pcampaignid=web_share"
            class="nav-item"
            id="downloadNavTrigger"
            data-i18n="nav_download"
            target="_blank"
            >Download</a
          >
          <a href="about.html" class="nav-item" data-i18n="nav_about">About</a>
        </nav>

        <!-- Right Actions (Language + Burger Menu) -->
        <div class="header-actions">
          <!-- Native Language Selector -->
          <div class="lang-selector">
            <select
              id="langSelect"
              aria-label="Select Language"
              data-i18n-attr='{"aria-label":"nav_select_lang"}'
            >
              <option value="en" selected>En</option>
              <option value="es">Es</option>
            </select>
          </div>

          <!-- Burger Icon Button (Only visible on mobile) -->
          <button class="burger-menu" id="burgerBtn" aria-label="Toggle menu">
            <span class="burger-bar"></span>
            <span class="burger-bar"></span>
            <span class="burger-bar"></span>
          </button>
        </div>
      </div>
    </header>

    <!-- Download App Modal Popup -->
    <div class="modal-overlay" id="downloadModal" aria-hidden="true">
      <div class="modal-card">
        <!-- Close Button -->
        <button
          class="modal-close-btn"
          id="closeModalBtn"
          aria-label="Close popup"
          data-i18n-attr='{"aria-label":"close_popup"}'
        >
          &times;
        </button>

        <div class="modal-header-content">
          <div class="modal-icon-badge">\u{1F4F1}</div>
          <h2 data-i18n="get_app">Get the App</h2>
          <p data-i18n="modal_stay_connected_msg">
            Stay connected on the go. Choose your mobile platform to begin
            downloading.
          </p>
        </div>

        <!-- Download Options -->
        <div class="download-options-container">
          <!-- iOS Download Option -->
          <a href="${this._iosUrl}" class="download-platform-btn" target="_blank">
            <div class="platform-icon">
              <i class="fa-brands fa-apple"></i>
            </div>
            <div class="platform-details">
              <span class="platform-sub" data-i18n="modal_download_on"
                >Download on the</span
              >
              <span class="platform-title" data-i18n="app_store"
                >App Store</span
              >
            </div>
          </a>

          <!-- Android Download Option -->
          <a href="${this._androidUrl}" class="download-platform-btn" target="_blank">
            <div class="platform-icon">
              <i class="fa-brands fa-android"></i>
            </div>
            <div class="platform-details">
              <span class="platform-sub" data-i18n="modal_get_it_on"
                >Get it on</span
              >
              <span class="platform-title" data-i18n="google_play"
                >Google Play</span
              >
            </div>
          </a>
        </div>
      </div>
    </div>
    `;
    }
    connectedCallback() {
        this.render();
        const switcher = this.shadowRoot.getElementById("langSelect");
        (0, _translatorJs.i18n).initFromElement(switcher);
        this.initDownloadButton();
        this.initMobileNav();
    }
    initMobileNav() {
        const burgerBtn = this.shadowRoot.getElementById("burgerBtn");
        const mobileNav = this.shadowRoot.getElementById("mobileNav");
        burgerBtn.addEventListener("click", ()=>{
            burgerBtn.classList.toggle("open");
            mobileNav.classList.toggle("open");
        });
    }
    initDownloadButton() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const downloadBtn = this.shadowRoot.getElementById("downloadNavTrigger");
        // Modal DOM References
        const downloadModal = this.shadowRoot.getElementById("downloadModal");
        const closeModalBtn = this.shadowRoot.getElementById("closeModalBtn");
        const downloadNavTrigger = this.shadowRoot.getElementById("downloadNavTrigger");
        if (!downloadBtn) return;
        // 3. Evaluate device type and apply the property values
        if (/android/i.test(userAgent)) {
            downloadBtn.href = this._androidUrl;
            downloadBtn.textContent = "Google Play";
        } else if (/iPad|iPhone|iPod/i.test(userAgent)) {
            downloadBtn.href = this._iosUrl;
            downloadBtn.textContent = "App Store";
        } else {
            downloadBtn.href = this._desktopUrl;
            downloadBtn.textContent = "Desktop App";
            // Helper functions to open and close
            const openModal = (e)=>{
                e.preventDefault();
                downloadModal.classList.add("modal-open");
                downloadModal.setAttribute("aria-hidden", "false");
            };
            const closeModal = ()=>{
                downloadModal.classList.remove("modal-open");
                downloadModal.setAttribute("aria-hidden", "true");
            };
            // Event Trigger Listeners
            if (downloadNavTrigger) downloadNavTrigger.addEventListener("click", openModal);
            closeModalBtn.addEventListener("click", closeModal);
            // Close modal instantly if the user clicks out in the blurred layout mask area
            downloadModal.addEventListener("click", (e)=>{
                if (e.target === downloadModal) closeModal();
            });
            // Accessibility: Allow hitting the Escape key to exit out of the modal frame
            document.addEventListener("keydown", (e)=>{
                if (e.key === "Escape" && downloadModal.classList.contains("modal-open")) closeModal();
            });
        }
    }
}
// Register the custom elements
customElements.define("custom-header", CustomHeader);

},{"../scripts/translator.js":"dXlaA","url:../styles/global.css":"4fKTw","url:../images/logo.png":"gnnvv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4fKTw":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ekcZ8");

},{}],"gnnvv":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lcoAX");

},{}],"kTvFh":[function(require,module,exports,__globalThis) {
class CustomFooter extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `
            <footer class="site-footer">
      <div class="footer-container">
        <p class="copyright-text" data-i18n="foot_copyright">
          &copy; 2026 ChatMurcianys. All rights reserved.
        </p>

        <!-- Social Media Icons using Font Awesome -->
        <div class="footer-socials">
          <a
            href="https://www.facebook.com/profile.php?id=100048617843429"
            class="social-icon-link"
            aria-label="Facebook"
          >
            <i class="fa-brands fa-facebook-f"></i>
          </a>
          <a
            href="https://www.instagram.com/chatmurcianys/"
            class="social-icon-link"
            aria-label="Instagram"
          >
            <i class="fa-brands fa-instagram"></i>
          </a>
          <a
            href="https://x.com/ChatMurcianys"
            class="social-icon-link"
            aria-label="Twitter"
          >
            <i class="fa-brands fa-x-twitter"></i>
          </a>
        </div>
      </div>
    </footer>
        `;
    }
}
// Register the custom elements
customElements.define("custom-footer", CustomFooter);

},{}],"bBdLh":[function(require,module,exports,__globalThis) {
class FlexibleSkeleton extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
        this._loading = true;
        this._error = false;
    }
    static get observedAttributes() {
        return [
            "loading",
            "error"
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) return;
        if (name === "loading") this._loading = newValue !== "false" && newValue !== null;
        if (name === "error") this._error = newValue !== "false" && newValue !== null;
        this.updateState();
    }
    connectedCallback() {
        this.render();
        this.updateState();
    }
    render() {
        this.shadowRoot.innerHTML = `
    <style>
      :host { display: block; }

      /* Default fallback style blocks - hidden state */
      slot[name="loading"], slot[name="content"], slot[name="error"] {
        display: none !important;
      }

      /* --- THE STATE SWAP ENGINE --- */
      :host([error]) slot[name="error"] { display: block !important; }
      :host([loading]:not([error])) slot[name="loading"] { display: block !important; }
      :host(:not([loading]):not([error])) slot[name="content"] { display: block !important; }
    </style>
    
    <slot name="loading"></slot>
    <slot name="content"></slot>
    <slot name="error"></slot>
  `;
    }
    updateState() {
        if (this._error) this.setAttribute("error", "");
        else this.removeAttribute("error");
        if (this._loading) this.setAttribute("loading", "");
        else this.removeAttribute("loading");
    }
}
customElements.define("custom-skeleton", FlexibleSkeleton);

},{}]},["awxwA"], "awxwA", "parcelRequire460e", {})

//# sourceMappingURL=public.e8b6657d.js.map
